import { LdButton } from "@liquid/react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import { ErrorCard, StyledPage } from "@src/components";
import { Footer } from "@src/features";
import { paths } from "@src/router/paths";

import { StyledButtonsContainer } from "./NotFoundPage.style";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <StyledPage>
        <ErrorCard
          title="Sorry, we can't find the page you're looking for."
          subtitle="Try one of these pages:"
        >
          <StyledButtonsContainer>
            <LdButton
              onClick={() => navigate(-1)}
              data-testid="previous-page-button"
            >
              Previous Page
            </LdButton>
            <Link
              to={paths.root}
              style={{ textDecoration: "none" }}
              data-testid="dashboard-link"
            >
              <LdButton>Dashboard</LdButton>
            </Link>
          </StyledButtonsContainer>
        </ErrorCard>
      </StyledPage>
      <Footer />
    </>
  );
};

export { NotFoundPage };
